import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

// RxJs
import { Observable, tap } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';

// NgRX
import { Store } from '@ngrx/store';
import { AppState } from '@core/store/reducers';

// Environments
import { environment as ENV } from '@environments/environment';
import { selectSessionUserState } from '@core/store/selectors/session.selectors';

// Models
import { User } from '@core/models/session.interface';
import { UserRole } from '@core/models/maintainer.interface';
import { AutoPayCase } from '@core/models/warranty.interface';
import { GraphQLService } from '@core/providers/services/graphql/graphql.service';



@Injectable({
  providedIn: 'root'
})
export class WarrantyService implements OnInit {

  public user!: User;


  constructor(
    private graphQLService: GraphQLService,
    private readonly httpClient: HttpClient,
    private readonly store: Store<AppState>,
  ) {
    this.getUserSession();

  }


  ngOnInit(): void {
    this.getUserSession();
  }


  private getUserSession(): void {
    this.store.select(selectSessionUserState).pipe(
      takeWhile(() => !this.user?.email),
    ).subscribe(user => this.user = user!);
  }


  public fillOutContractsTableSelectors(): Observable<{ centers: any[], cases: any[] }> {
    return this.graphQLService.query(`
      query {
        centers:allCentroCosto {
          value:centroCostoId
          option:nombre
        }
      }`, { }, true).pipe(
      map(({ data: { centers }}: any) => ({ centers: [{ value: '', option: 'Todas' }, ...centers ], cases: [
        { value: '', option: 'Todos' },
        { value: 'INCOBRABLE', option: 'Incobrables' },
        { value: 'CRITICO', option: 'Críticos' },
        { value: 'MEDIO', option: 'Medios' },
        { value: 'BAJO', option: 'Bajos' }
      ]})
    ));
  }


  public getContracts(page: number = 1, search: string = '', store: number = 723, criticality: string = 'Critical'): Observable<any> {
    const params = new HttpParams().appendAll({
      limit: 5, page, store, search, cases: criticality
    });

    console.log({ page, store, search, case: criticality });

    return this.httpClient.get(`${ ENV.URI }${ ENV.WARRANTY.RECOVERY.GET_CONTRACTS }`, { params });
  }


  public generateCsrfToken(): Observable<any> {
    return this.httpClient.get(`${ ENV.URI }${ ENV.WARRANTY.RECOVERY.CSRF_TOKEN }`);
  }


  public exportContractsToExcel(store: string): Observable<any> {
    const [ date, time, name = 'cobroGarantia' ] = (new Date()).toLocaleString().split(', '),
          filename = `${ name }${ date.replaceAll('/', '') }${ time.replace(/\D/g, '')}`,
          params = new HttpParams().appendAll({
            filename, store, email: this.user.email,
            profile: this.user.role === 'ADMINISTRADOR' ? 'admin' : 'collab'
          });

    return this.httpClient.get(`${ ENV.URI }${ ENV.WARRANTY.RECOVERY.EXPORT_CONTRACTS_TO_EXCEL }`, { params });
  }

  public getAutoPayCases(): Observable<Record<string, Omit<AutoPayCase, 'name'>>> {
    return this.httpClient.get<AutoPayCase[]>(`${ ENV.URI }${ ENV.WARRANTY.RECOVERY.GET_AUTOPAY_CASES }`).pipe(
      map((cases: AutoPayCase[]) => cases.reduce((acc, { name, ...rest }) => ({ ...acc, [name]: rest }), {} as Record<string, Omit<AutoPayCase, 'name'>>))
    );
  }
}
